<template>
  <div class="upload-container">
    <el-button size="mini" type="primary" @click="dialogVisible = true"> 上傳 </el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="title"
      append-to-body
      :width="device == 'mobile' ? '90%' : '60%'"
    >
      <div class="dialog-content" v-loading="loading">
        <div class="album-group__dialog">
          <div class="album-group__create">
            <el-input
              type="text"
              size="small"
              class="album-group__input"
              placeholder="請輸入相簿名稱"
              v-model.trim="newAlbumName"
              @keyup.enter.native="handleAddAlbum"
            >
            </el-input>
            <el-button
              type="primary"
              plain
              size="small"
              class="album-group__button"
              @click="handleAddAlbum"
              icon="el-icon-folder-add"
              >新增相簿</el-button
            >
          </div>
          <div
            v-for="groupTag in albumGroupTag"
            :key="groupTag.id"
            @click="handleSelectGroupTag(groupTag)"
            class="album-group album-group--desktop"
          >
            <div class="album-content">
              <div style="display: flex; align-items: center; gap: 0 8px">
                <div class="icon-container">
                  <el-icon
                    name="folder"
                    class="icon-folder"
                    :class="{
                      'icon-folder--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                    }"
                  ></el-icon>
                </div>
                <span
                  class="album-group__name"
                  :class="{
                    'album-group__name--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                  }"
                >
                  {{ groupTag.groupTagName }}
                </span>
              </div>
              <el-popconfirm
                title="確定要刪除此相簿嗎?"
                v-show="!!groupTag.groupTagId"
                @confirm="handleDeleteConfirm(groupTag.groupTagId)"
                confirm-button-text="確認"
                cancel-button-text="取消"
              >
                <div class="icon-container__delete" slot="reference">
                  <el-icon name="delete" class="icon-delete"></el-icon>
                </div>
              </el-popconfirm>
            </div>
          </div>
        </div>

        <div class="album-group__container">
          <div
            v-for="groupTag in albumGroupTag"
            :key="groupTag.id"
            class="album-group"
            :class="{ 'album-group--active': selectedAlbumGroupTag.id == groupTag.groupTagId }"
            @click="handleSelectGroupTag(groupTag)"
          >
            <div
              style="
                width: 100%;
                display: flex;
                gap: 8px;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center; gap: 0 8px">
                <div class="icon-container">
                  <el-icon
                    name="folder"
                    class="icon-folder"
                    :class="{
                      'icon-folder--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                    }"
                  ></el-icon>
                </div>
                <span
                  class="album-group__name"
                  :class="{
                    'album-group__name--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                  }"
                >
                  {{ groupTag.groupTagName }}
                </span>
              </div>
              <el-popconfirm
                :title="
                  !groupTag.groupTagId ? '是否要刪除未分類相簿內所有照片？' : '確定要刪除此相簿嗎?'
                "
                @confirm="handleDeleteConfirm(groupTag.groupTagId)"
                confirm-button-text="確認"
                cancel-button-text="取消"
              >
                <div class="icon-container__delete" slot="reference">
                  <el-icon name="delete" class="icon-delete"></el-icon>
                </div>
              </el-popconfirm>
            </div>
          </div>
        </div>
        <div class="uploadImage__dialog">
          <p class="uploadImage__dialog__title">
            <span>上傳至：</span>
            <el-icon name="folder" class="icon-folder icon-folder--active"></el-icon>
            <span style="font-weight: 500">{{ selectedAlbumGroupTag.name }}</span>
          </p>

          <el-upload
            :multiple="true"
            v-model:file-list="fileList"
            action="#"
            accept="image/*"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :on-change="handleUploadChange"
            :before-upload="beforeUpload"
            ref="uploadAgencyAlbumImage"
            class="editor-slide-upload"
            list-type="picture-card"
            :auto-upload="false"
          >
            <el-button type="text" icon="el-icon-plus"></el-button>
          </el-upload>
        </div>
      </div>

      <footer class="uploadImage__footer">
        <el-button @click="dialogVisible = false" :disabled="loading"> 取消 </el-button>
        <el-button type="primary" @click="handleSubmit" :disabled="loading"> 確認 </el-button>
      </footer>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import { convertFileToBase64 } from '@/utils/funcs'
import { savePhotoToPublicAlbumGroupTag, deletePhotoToPublicAlbumGroupTag } from '@/api/travel'
export default {
  name: 'EditorSlideUpload',
  props: {
    title: {
      type: String,
      default: '上傳圖片',
    },
    travelId: {
      type: [String, Number],
      default: '',
    },
    groupNo: {
      type: [String, Number],
      default: '',
    },
    albumGroupTag: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      newAlbumName: '',
      listObj: {},
      fileList: [],
      selectedAlbumGroupTag: {
        id: 0,
        name: '未分類相簿',
      },
    }
  },
  computed: {
    apiUrl() {
      const action = 'TravelSettings/savePublicAlbum'
      return `${process.env.VUE_APP_BASE_API}/${action}`
    },
    ...mapGetters(['device']),
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
    },
    async handleSubmit() {
      const vm = this
      const files = []
      for (var i = 0; i < this.fileList.length; i++) {
        const f = this.fileList[i]
        // 遍历files数组，将file添加到FormData对象中
        await convertFileToBase64(f).then((resolve, reject) => {
          console.log(resolve, reject)
          const data = {
            fileName: f.name,
            base64: resolve,
            mapGroupTagId: this.selectedAlbumGroupTag.id,
            mapGroupTagName: this.selectedAlbumGroupTag.name,
          }
          files.push(data)
        })
      }
      // 请求后端接口
      const album = []
      album.push({ files: files })
      const formatData = {
        travelID: this.travelId,
        token: getToken(),
        album: album,
      }
      this.loading = true
      axios
        .post(vm.apiUrl, formatData, {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: 'Bearer ' + getToken(),
          },
        })
        .then(response => {
          console.log(response)
          let success = response.data.success
          if (success) {
            vm.fileList.forEach(file => {
              file.status = 'success'
            })
            // this.$emit("successCBK", arr);
            this.$message.success('上傳成功!')
            this.$refs.uploadAgencyAlbumImage.clearFiles()
            this.listObj = {}
            this.fileList = []
            this.dialogVisible = false
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('上傳失敗!')
        })
        .finally(() => {
          this.fileList = []
          this.loading = false
        })
    },
    handleUploadChange(file) {
      console.log('file')
      console.log(file)
      this.fileList.push(file.raw)
    },
    handleSuccess(response, file) {
      console.log('success')
      console.log(response, file)
      // const uid = file.uid;
      // const objKeyArr = Object.keys(this.listObj);
      // for (let i = 0, len = objKeyArr.length; i < len; i++) {
      //     if (this.listObj[objKeyArr[i]].uid === uid) {
      //         this.listObj[objKeyArr[i]].url = response.files.file;
      //         this.listObj[objKeyArr[i]].hasSuccess = true;
      //         return;
      //     }
      // }
    },
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      this.fileList.splice(index, 1)
    },
    beforeUpload(file) {
      console.log('beforeUpload')
      console.log(file)

      // const _self = this;
      // const _URL = window.URL || window.webkitURL;
      // const fileName = file.uid;
      // this.listObj[fileName] = {};
      // return new Promise((resolve, reject) => {
      //     const img = new Image();
      //     img.src = _URL.createObjectURL(file);
      //     img.onload = function () {
      //         _self.listObj[fileName] = {
      //             hasSuccess: false,
      //             uid: file.uid,
      //             width: this.width,
      //             height: this.height,
      //         };
      //     };
      //     resolve(true);
      // });
    },
    handleSelectGroupTag(albumGroupTag) {
      console.log(albumGroupTag)
      this.selectedAlbumGroupTag.id = albumGroupTag.groupTagId
      this.selectedAlbumGroupTag.name = albumGroupTag.groupTagName
    },
    // 新增共享相簿群組
    async handleAddAlbum() {
      if (this.newAlbumName == '') return
      // 判斷是否已存在相同的名稱
      const hasAlbumName = this.albumGroupTag.some(obj => obj.groupTagName === this.newAlbumName)
      if (hasAlbumName) {
        alert('此相簿已存在！')
        this.newAlbumName = ''
        return
      }
      const params = {
        travelID: this.travelId,
        groupTagName: this.newAlbumName,
        token: getToken(),
      }
      this.loading = true
      await savePhotoToPublicAlbumGroupTag(params)
        .then(res => {
          if (res.success) {
            this.$notify({
              title: '提示',
              message: '新增相簿成功',
              type: 'success',
            })
            this.$emit('getGroupTagList')
            this.newAlbumName = ''
          }
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    // 刪除共享相簿群組
    async handleDeleteConfirm(groupTagId) {
      const params = {
        travelID: this.travelId,
        groupTagId: groupTagId,
      }
      this.loading = true
      const data = await deletePhotoToPublicAlbumGroupTag(params)
      this.loading = false
      if (data.success) {
        if (this.selectedAlbumGroupTag.id == groupTagId) {
          this.selectedAlbumGroupTag = {
            id: 0,
            name: '未分類相簿',
          }
        }
        this.$emit('getGroupTagList')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  display: flex;
  gap: 0 1rem;
}

.editor-slide-upload {
  // margin-bottom: 20px;

  // ::v-deep .el-upload--picture-card {
  //     width: 100%;
  // }
}

.album-group__button {
  width: 100%;
  margin: 10px 0;
}

.uploadImage__dialog {
  max-height: 60vh;
  overflow: auto;
  flex-grow: 1;

  &__title {
    display: flex;
    align-items: center;
    gap: 0 8px;
    font-size: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #ddd;
  }
}

.uploadImage__footer {
  padding-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.album-group__add {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;

  small {
    font-size: 0.5rem;
    letter-spacing: 0.05em;
  }
}

.album-group {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;

  :hover {
    .icon-folder,
    .album-group__name {
      color: #1890ff;
    }
  }

  &__dialog {
    min-width: 200px;
    width: fit-content;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 12px;
    border: 1px solid #ddd;
    background: #fafafa;
    max-height: 60vh;
    overflow-y: auto;
    border-radius: 5px;
  }

  &__name {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    &--active {
      color: #1890ff;
    }
  }
}

.icon-container {
  display: flex;
  justify-content: center;
}

.icon-container__delete {
  display: flex;
  justify-content: flex-end;

  :hover {
    color: #c33f3f;
  }
}

.icon-folder {
  font-size: 1rem;
  color: #ddd;

  &--active {
    color: #1890ff;
  }
}

.icon-delete {
  font-size: 1rem;
  color: #ddd;
}

.album-content {
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
}
.album-group__container {
  display: none;
}

@media (max-width: 920px) {
  .dialog-content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0;
  }

  .album-group__create {
    display: flex;
    align-items: center;
    gap: 0 0.5rem;
  }

  .album-group__input {
    width: fit-content;
  }

  .album-group__button {
    width: fit-content;
  }

  .album-group__dialog {
    width: 100%;
    border: none;
    background: white;
  }

  .album-group--desktop {
    display: none;
  }

  .album-group__container {
    display: flex;
    gap: 0 8px;
    padding-bottom: 24px;
    width: 95%;
    white-space: nowrap;
    overflow-x: scroll;

    .album-group {
      min-width: fit-content;
      border: 1px solid #ddd;
      padding: 8px;
      border-radius: 5px;
      font-weight: 500;
      cursor: pointer;
    }

    .album-group--active {
      color: #ffba00;
      font-weight: 700;
    }

    .icon-delete {
      color: #aaa9a9;
    }

    .icon-delete:hover {
      color: #c33f3f;
    }
  }
  .uploadImage__dialog {
    width: 100%;
  }
}
</style>
